import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { useAtom } from 'jotai';
import { NUMBER_OF_SWATCHES_TO_SHOW } from 'commons/constants';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';
import ProductCardStaticPlaceholderGroup from 'components/consumer/ProductCardStaticPlaceholderGroup';
import { createSearchProductClickHandler } from 'components/consumer/consumer-search/algolia-insights-helpers/createSearchProductClickHandler';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';
import ShowroomDisplayContext from 'components/consumer/category-page-algolia/hooks/ShowroomDisplayContext';
import useUserData from 'data-hooks/useUserData';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';
const AdvancedSearchProductsGrid = t0 => {
  const $ = _c(19);
  const {
    products,
    eagerImageCount: t1,
    trailingPlaceholderCount: t2
  } = t0;
  const eagerImageCount = t1 === undefined ? 0 : t1;
  const trailingPlaceholderCount = t2 === undefined ? 0 : t2;
  const mobileColumnCount = useMobileColumnCount();
  const [, setLastInsightsClick] = useAtom(lastInsightsClickAtom);
  const showroomData = useContext(ShowroomDisplayContext);
  const {
    isLoggedIn
  } = useUserData();
  const t3 = !isLoggedIn;
  let t4;
  if ($[0] !== t3) {
    t4 = {
      skip: t3
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    data: favoritedProductIdsData
  } = useQuery(GET_FAVORITED_PRODUCT_IDS, t4);
  let t5;
  if ($[2] !== favoritedProductIdsData?.productIds) {
    t5 = favoritedProductIdsData?.productIds ?? [];
    $[2] = favoritedProductIdsData?.productIds;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const favoritedProductIds = t5;
  let t6;
  if ($[4] !== products) {
    t6 = products?.findIndex(Boolean) ?? -1;
    $[4] = products;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const firstProductIndex = t6;
  let t7;
  if ($[6] !== eagerImageCount || $[7] !== favoritedProductIds || $[8] !== firstProductIndex || $[9] !== products || $[10] !== setLastInsightsClick || $[11] !== showroomData) {
    t7 = !!products && products?.length > 0 && products?.map((product, index) => {
      if (!product) {
        return <ProductCardStaticPlaceholder key={`product-slot-placeholder-${index}`} />;
      }
      const {
        campaign,
        id,
        isClearance,
        isHidden,
        label,
        meta,
        name,
        onDisplayInShowroomSlug,
        path,
        position,
        productFamily,
        productLabel,
        productType,
        quickship,
        secondaryImage,
        secondaryImageCropData,
        slug,
        variants,
        variantsToShow,
        variantsTotal,
        moreVariantsCount,
        bypass_stock,
        algoliaMetaData: t8
      } = product;
      const algoliaMetaData = t8 === undefined ? {} : t8;
      return <ProductCardStatic key={`advanced-search-product-${id}-${variantsToShow?.[0]?.sku ?? variants?.[0]?.sku ?? ""}`} campaign={campaign} disableImageLazyLoading={index < eagerImageCount} disablePDPPrefetch={true} prioritizeImage={eagerImageCount > 0 && index === firstProductIndex} enableMobileCarousel={true} hidden={isHidden} id={id} isClearance={isClearance} isFavorited={favoritedProductIds.includes(id)} label={label} layout="full" moreVariantsCount={moreVariantsCount ?? variantsTotal - (variantsToShow?.length ?? 0)} name={name} onDisplayInShowroomSlug={onDisplayInShowroomSlug || (showroomData?.productsOnDisplay?.includes(id) ? showroomData.slug : undefined)} path={path} position={position} productFamily={productFamily} productLabel={productLabel} productType={productType} quickship={quickship} secondaryImage={`${secondaryImage}`} secondaryImageCropData={secondaryImageCropData} slug={slug} variants={variants} variantsToShow={variantsToShow?.map(_temp) ?? variants?.slice(0, NUMBER_OF_SWATCHES_TO_SHOW).map(_temp2) ?? []} variantsTotal={variantsTotal} meta={meta} bypass_stock={bypass_stock} onClick={createSearchProductClickHandler(algoliaMetaData, setLastInsightsClick, {
        index,
        productId: id
      })} />;
    });
    $[6] = eagerImageCount;
    $[7] = favoritedProductIds;
    $[8] = firstProductIndex;
    $[9] = products;
    $[10] = setLastInsightsClick;
    $[11] = showroomData;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== trailingPlaceholderCount) {
    t8 = trailingPlaceholderCount > 0 && <ProductCardStaticPlaceholderGroup count={trailingPlaceholderCount} />;
    $[13] = trailingPlaceholderCount;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== mobileColumnCount || $[16] !== t7 || $[17] !== t8) {
    t9 = <div className="min-h-[400px]"><ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t7}{t8}</ProductCardGridUI></div>;
    $[15] = mobileColumnCount;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default AdvancedSearchProductsGrid;
function _temp(variant_0) {
  return {
    ...variant_0,
    image: `${variant_0?.image}`
  };
}
function _temp2(variant) {
  return {
    ...variant,
    image: `${variant?.image}`
  };
}